import React, {useContext, useEffect, useState} from 'react';
import {toast} from "react-toastify";
import {AlertMessage} from "../../utils/alert-message";

import TemplateDefault from "../../components/template-default";
import Card from '../../components/card';
import InputForm from '../../components/input-form';
import Button from '../../components/button';
import UserService from "../../services/user-service";
import {useNavigate} from "react-router-dom";
import {ProjectContext} from "../../context/project-context";

const MyUser = () => {
    const {user, getFirstPath} = useContext(ProjectContext);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const navigate = useNavigate();

    const submit = () => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append('_method', 'PUT');
        formData.append("oldPassword", oldPassword)
        formData.append("newPassword", newPassword)
        formData.append("confirmNewPassword", confirmNewPassword)

        const response = UserService.updatePassword(formData);

        setOldPassword("");
        setNewPassword("");
        setConfirmNewPassword("");

        response
            .then(({data}) => {
                toast.success("Salvo com sucesso.")
            })
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
            .finally(() => setIsLoading(false));
    }

    return (
        <TemplateDefault title="Alteração de senha" isLoading={isLoading}>
            <Card>
                <div className="grid grid-cols-12 gap-4 sm:grid-cols-05">
                    <InputForm id="oldPassword" name="oldPassword" label="Senha atual" col="col-span-12 lg:col-span-4" type={"password"}
                               value={oldPassword} onChange={({target: {value}}) => setOldPassword(value)} />
                    <InputForm id="newPassword" name="newPassword" label="Nova senha" col="col-span-12 lg:col-span-4" type={"password"}
                               value={newPassword} onChange={({target: {value}}) => setNewPassword(value)} />
                    <InputForm id="confirmNewPassword" name="confirmNewPassword" label="Nova senha (confirmação)"
                               col="col-span-12 lg:col-span-4" type={"password"} value={confirmNewPassword} onChange={({target: {value}}) => setConfirmNewPassword(value)} />
                </div>
                <div className="flex justify-end gap-3 mt-5">
                    <Button onClick={() => navigate(getFirstPath(user.permissions))} target="warning">
                        Cancelar
                    </Button>
                    <Button onClick={submit} type="submit" target="success">
                        Salvar
                    </Button>
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default MyUser;